import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'zoom-buttons',
  templateUrl: './zoom-buttons.component.html',
  styleUrls: ['./zoom-buttons.component.scss']
})
export class ZoomButtonsComponent implements OnInit {
  @Output() zoomIn = new EventEmitter();
  @Output() zoomOut = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
